import { Modal } from "@mui/material";
import Styles from "./ConfirmationModal.module.css";
import React, { useState } from "react";
import { ErrorMessage } from "../Toast/ErrorMessage";

const ConfirmationModal = ({
  open,
  handleClose,
  data,
  header,
  note,
  handleSubmit,
  loading,
  customStyle,
  commentBox,
  commentBoxHeading,
  handleCommentChange,
  commentInit,
  viewOk,
}) => {
  const [comment, setComment] = useState("");

  const handleCommentSubmit = () => {
    // Require comment only when caller asks for it
    if (commentInit && !comment?.trim()) {
      return ErrorMessage("Comment Required");
    }

    if (handleCommentChange) handleCommentChange(comment);
    if (handleSubmit) handleSubmit(comment);
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="verify-popup"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.popupModal}`}>
        <div
          className={`display_flex_row modalHeading_confirmation ${Styles.modalHeading}`}
        >
          <div className="headingText">{header || "Confirmation"}</div>
        </div>
        <div
          className={`display_flex_column_gap_8 ${Styles.confirmTextContainer}`}
          style={customStyle}
        >
          <div className={`display_flex_row_center `}>
            <div className={Styles.confirm_text}>{data || "Confirmation"}</div>
          </div>
          {note && (
            <div className={Styles.confirm_text}>
              <b>Note: </b>
              {typeof note === "string" ? (
                note.split("\n").map((line, index) => (
                  <span key={index}>
                    {line
                      .split("**")
                      .map((part, i) =>
                        i % 2 === 0 ? part : <strong key={i}>{part}</strong>,
                      )}
                    {index < note.split("\n").length - 1 && <br />}
                  </span>
                ))
              ) : (
                note
              )}
            </div>
          )}
          {commentBox && (
            <div className={Styles.commentBox}>
              {commentBoxHeading ? (
                <div>{commentBoxHeading}</div>
              ) : (
                <>
                  {" "}
                  <div>{commentInit ? "Reason of Rejection" : "Comments"}</div>
                </>
              )}
              <input
                placeholder="Enter text"
                type="text"
                value={comment}
                onChange={(e) => {
                  setComment(e.target.value);
                  if (
                    handleCommentChange &&
                    typeof handleCommentChange === "function" &&
                    commentBox
                  ) {
                    handleCommentChange(e.target.value);
                  }
                }}
              />
            </div>
          )}
        </div>
        <div className={`display_flex_row ${Styles.confirm_button_container}`}>
          {!viewOk && (
            <button
              type="button"
              onClick={() => handleClose()}
              disabled={loading}
            >
              No
            </button>
          )}
          <button
            type="button"
            onClick={() => {
              if (commentBox) {
                handleCommentSubmit();
              } else {
                if (handleSubmit) handleSubmit();
              }
              setComment("");
            }}
            disabled={loading}
          >
            {loading ? "Processing..." : viewOk ? "OK" : "Yes"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
